export const CATALOG_FEEDBACK_RATING_MIN = 1;
export const CATALOG_FEEDBACK_RATING_MAX = 5;
export const CATALOG_FEEDBACK_PAGINATION = 3;
